module.exports = __webpack_public_path__ + "07be329de20f14c239c5534e57f64ba8.svg";